/**
 * This file contains constants for help wizard URLs hosted in storylane.
 *
 * HELP_URL_LOGIN: URL for the "How to log in" tutorial
 * HELP_URL_ADD_TEAM_MEMBER: URL for the "How to add new team members" tutorial
 * HELP_URL_BILLING: URL for the "How to manage your subscription" tutorial
 * HELP_URL_UPLOAD_DOCUMENT: URL for the "How to upload documents and download extractions" tutorial 
 * HELP_URL_EDIT_DOCUMENT_EXTRACTIONS: URL for the "How to review and edit extractions" tutorial
 */
export const HELP_URL_LOGIN = "https://evolution-ai.storylane.io/share/qbqqb14hx8gx"
export const HELP_URL_ADD_TEAM_MEMBER = "https://evolution-ai.storylane.io/share/a3rbv7cvaic3"
export const HELP_URL_BILLING = "https://evolution-ai.storylane.io/share/1tmv4uurhqhg"
export const HELP_URL_UPLOAD_DOCUMENT = "https://evolution-ai.storylane.io/share/qazgbrhpkcfv"
export const HELP_URL_EDIT_DOCUMENT_EXTRACTIONS = "https://evolution-ai.storylane.io/share/tacgihgnahyi"
export const HELP_PAGE_CLASSIFICATION = "https://evolution-ai.storylane.io/share/7i646knsg7x2"
